import React from 'react';
import { geolocated } from 'react-geolocated';
class Demo extends React.Component {
    state = {
        count: 1,
    }
    constructor(props) {
        super(props);
    }
    render() {
        return !this.props.isGeolocationAvailable
            ? <div className="alert alert-danger">Browser ของคุณไม่สนับสนุน Geolocation</div>
            : !this.props.isGeolocationEnabled
                ? <div>case3</div>
                : this.props.coords
                    ? <div><br /><div className="alert alert-danger" style={{ marginTop: 10 }}>ไม่สามารถเรียกดูตำแหน่งปัจจุบันของคุณได้ </div></div>
                    : this.props.isGeolocationEnabled == false && this.props.coords === null
                        ? <div>case1</div>
                        : <div style={{ textAlign: 'center' }}>
                            <p>กำลังโหลดตำแหน่งของคุณ</p>
                            <div className="loader" style={{ textalign: 'center', margin: '10px auto', width: 5 + 'em', height: 5 + 'em' }}>
                            </div></div>
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.isGeolocationEnabled == true && nextProps.coords != null) {
            if (!this.props.clicked && this.props.lat) {
                this.props.setdefaultlocation(this.props.lat, this.props.lng)
                this.props.setlocation(this.props.lat, this.props.lng)
            } else {
                this.setState({ count: this.state.count + 1 })
                this.props.setdefaultlocation(nextProps.coords.latitude, nextProps.coords.longitude)
                this.props.setlocation(nextProps.coords.latitude, nextProps.coords.longitude)
            }
        }
        else if (nextProps.isGeolocationEnabled == false) {
            this.props.setdefaultlocation(13.896995, 100.6064463)
            this.props.setlocation(13.896995, 100.6064463)
        }
    }
}
export default geolocated({
    positionOptions: {
        enableHighAccuracy: true,
    },
    userDecisionTimeout: 30000,
})(Demo);


// WEBPACK FOOTER //
// ./src/components/getgeolocation.js